/* modals */
(function () {
  var links = document.querySelectorAll('a');
  links.forEach((link) => {
    var href = link.href;
    if (href.includes('#vng-modal-')) {
      var target = href.split('#')[1];
      link.addEventListener('click', (event) => {
        event.preventDefault();
        var modal = document.getElementById(target);
        if (modal) {
          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
        };
      });
    };
  });
  var closeBtns = document.querySelectorAll('.vng-modal-close');
  closeBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      var modals = document.querySelectorAll('.vng-modal');
      modals.forEach((modal) => {
        modal.style.display = 'none';
        document.body.style.overflow = 'initial';
      });
    });
  });
}) ();
/* add target="_blank" */
(function () {
  var targetLinks = ['https://www.mwv-ulm.de/wb/wb-kontakt.php', 
                     'https://www.facebook.com/', 
                     'https://www.linkedin.com/', 
                     'https://www.youtube.com/'];
  var links = document.querySelectorAll('a');
  function addBlank(target) {
    links.forEach((link) => {
      if (link.href.includes(target)) {
        link.setAttribute('target', '_blank');
        return;
      }
    })
  };
  targetLinks.forEach((targetLink) => {
    addBlank(targetLink);
  });
}) ();
/* cart notes */
(function () {
  if (document.body.classList.contains('vng-cart')) {
    var output = document.getElementById('Cart-note');
    var vat = document.getElementById('vng-cart-vat');
    var reference = document.getElementById('vng-cart-reference');
    var note = document.getElementById('vng-cart-note');
    var invoice = document.getElementById('vng-cart-invoice');
    var inputs = [vat, reference, note, invoice];
    var checkoutBtn = document.getElementById('checkout');
    checkoutBtn.classList.add('vng-cart-btn-disabled');
    inputs.forEach((input) => {
      input.addEventListener('input', () => {
        var content = 'USt-Id:\n' + vat.value + '\n\n';
        content += 'Referenz:\n' + reference.value + '\n\n';
        content += 'Bemerkung / Aufbaunummer:\n' + note.value + '\n\n';
        content += 'E-Mail für Rechnungsversand:\n' + invoice.value;
        output.value = content;
        if (vat.value) {
          checkoutBtn.classList.remove('vng-cart-btn-disabled');
          required.classList.remove('vng-cart-required');
        } else {
          checkoutBtn.classList.add('vng-cart-btn-disabled');
        };
      });
    });
    var required = document.getElementById('vng-cart-required');
    checkoutBtn.addEventListener('click', () => {
      if (!vat.value) {
        event.preventDefault();
        required.classList.add('vng-cart-required');
      } else {
        required.classList.remove('vng-cart-required');
        checkoutBtn.classList.remove('vng-cart-btn-disabled');
      };
    });
  };
}) ();
// service map
(function () {
  const mapTarget = document.querySelector('#vng-map-target');
  if(mapTarget){
    const targetNode = document.getElementById('MainContent');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      	const mapSource = document.querySelector('.develic-loaded');
      	if(mapSource){
    	  	mapSource.remove();
    	  	mapTarget.appendChild(mapSource);
    		observer.disconnect();
      	}
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}) ();